<template>
	<a-layout class="layout-container">
		<a-layout-sider v-model="collapsed" :trigger="null" collapsible class="layout-sider">
			<img @click="menuClick('schoolDetail')" :class="['layout-logo', { 'layout-logo_collapsed': collapsed }]"
				:src="logo" alt="">
			<div class="layout-name" v-if="!collapsed">{{ schoolInfo.name || schoolName || "幼儿园" }}</div>
			<a-menu theme="light" mode="inline" :selected-keys="selectedKeys">
				<template v-if="hasTeacherRole || isManager">
					<a-menu-item key="school" @click="menuClick('school')">
						<svg-icon iconClass="school" class="layout-menu_icon"></svg-icon>
						<span class="layout-menu_name">学校管理</span>
					</a-menu-item>
					<a-menu-item key="klassCircle" @click="menuClick('klassCircle')">
						<svg-icon iconClass="klassCircle" class="layout-menu_icon"></svg-icon>
						<span class="layout-menu_name">班级圈</span>
					</a-menu-item>
					<a-menu-item key="album" @click="menuClick('album')">
						<svg-icon iconClass="album" class="layout-menu_icon"></svg-icon>
						<span class="layout-menu_name">成长手册</span>
					</a-menu-item>
					<a-menu-item key="sensitive" @click="menuClick('sensitive')">
						<svg-icon iconClass="sensitive" class="layout-menu_icon"></svg-icon>
						<span class="layout-menu_name">敏感词</span>
					</a-menu-item>
					<a-menu-item v-if="isManager" key="klassTask" @click="menuClick('klassTask')">
						<svg-icon iconClass="klassTask" class="layout-menu_icon"></svg-icon>
						<span class="layout-menu_name">发展评估</span>
					</a-menu-item>
					<a-menu-item v-else key="assessmentList" @click="menuClick('assessmentList')">
						<svg-icon iconClass="assessmentList" class="layout-menu_icon"></svg-icon>
						<span class="layout-menu_name">发展评估</span>
					</a-menu-item>
				</template>

				<a-menu-item key="external" @click="menuClick('external')">
					<svg-icon iconClass="external" class="layout-menu_icon"></svg-icon>
					<span class="layout-menu_name">资料分享</span>
				</a-menu-item>
			</a-menu>
		</a-layout-sider>
		<a-layout>
			<a-layout-header class="layout-header">
				<a-icon class="layout-header_menu trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'"
					@click="() => (collapsed = !collapsed)" />
				<div class="fr layout-header_user">

					<a-dropdown>
						<a href="javascript:;">
							<span class="layout-header_avatar" :style="getBgStyle(userInfo.avatar_url || avatar)"></span>
							<span class="layout-header_name">{{ userInfo.name }}</span>
						</a>
						<a-menu slot="overlay">
							<a-menu-item key="0">
								<a @click="menuClick('userInfo')" href="javascript:;">用户信息</a>
							</a-menu-item>
							<a-menu-item key="1">
								<a @click="menuClick('teacherDetail', { id: teacherInfo.id })" href="javascript:;">教师信息</a>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
					<span class="layout-header_logout" @click="logoutHandle">
						<svg-icon iconClass="logout"></svg-icon>
					</span>
				</div>
			</a-layout-header>
			<a-layout-content class="layout-content scroll-bar">
				<div class="layout-title" :class="$route.meta.classname">
					<span class="layout-title_parent" v-for="routeName in ($route.meta.parent || [])" :key="routeName"
						@click="menuClick(routeName)">
						{{ routeNameMap[routeName] || routeName }}
						<a-icon class="layout-title_icon" type="right" />
					</span>
					<span class="layout-title_cur"
						:class="{ 'layout-title_parent': !$route.meta.parent || !$route.meta.parent.length }">
						{{ routeNameMap[$route.name] || $route.name }}
					</span>
					<span v-if="$route.meta.showBack" class="fr layout-back" @click="backHandle"> <a-icon type="left" />
						返回</span>
				</div>
				<router-view />
				<a-back-top :visibilityHeight="500" :target="() => target" />
			</a-layout-content>
		</a-layout>
	</a-layout>
</template>

<script>
import avatar from "@/assets/images/avatar.png";
import logo from "@/assets/images/logo.png";
import { mapGetters } from "vuex";
import { teacherRolePermission } from "@/config/permission";
import { redirectLogin, filterRoutes } from "@/utils";
import routeNameMap from "@/config/routeNameMap";
import routeConst from "@/routes/constant";
import SchoolService from "@/api/schoolService";

export default {
	name: "layoyt",
	data() {
		return {
			collapsed: false,
			avatar,
			logo,
			routeNameMap,
			selectedKeys: [],
			target: null,
			schoolName: ""
		};
	},

	computed: {
		...mapGetters([
			"userInfo",
			"schoolInfo",
			"teacherInfo",
			"hasTeacherRole",
			"isManager",
		]),
		getBgStyle() {
			return function (thumbnail_url) {
				return {
					background: `url(${thumbnail_url}) no-repeat center center`,
					"background-size": "cover",
				};
			};
		},

		asyncRouteList() {
			let asyncRoutes = [];
			if (this.$store.getters.isManager) {
				asyncRoutes = routeConst.asyncRoutes;
			} else if (this.$store.getters.hasTeacherRole) {
				asyncRoutes = filterRoutes(teacherRolePermission, routeConst.asyncRoutes)
			} else {
				asyncRoutes = filterRoutes([], routeConst.asyncRoutes)
			}

			return asyncRoutes.map(item => item.name);
		}
	},

	watch: {
		$route: {
			handler(value) {
				if (!value.meta || !value.meta.parent) {
					this.selectedKeys = [];
					return;
				}
				const parent = value.meta.parent;
				this.selectedKeys = [parent[0] || value.name];

				this.routeHank(value)
			},
			deep: true,
			immediate: true,
		},
	},

	created() {
		this.$store.dispatch("getRelationShipListService");
		if (!this.$store.getters.isManager && !this.$store.getters.hasTeacherRole) {
			this.getShoolInfo();
		}
	},


	mounted() {
		this.target = document.querySelector('.layout-content');
	},

	methods: {
		getShoolInfo() {
			SchoolService.getSchoolInfoService({
				id: this.schoolInfo.id,
			}).then((res) => {
				this.schoolName = res.name;
			});
		},
		logoutHandle() {
			this.$confirm({
				title: "确定退出登录吗?",
				okType: "danger",
				onOk: () => {
					redirectLogin();
				},
			});
		},

		menuClick(routeName, query = {}) {
			if (this.$route.name === routeName) return;
			if (!this.asyncRouteList.includes(routeName)) {
				this.$message.warning("当前账号未有该路由的权限");
				return;
			}
			this.$router.push({ name: routeName, query });
		},

		viewUserInfo() {
			if (this.$route.name === "userInfo") return;
			this.$router.push({ name: "userInfo" });
		},

		backHandle() {
			this.$router.back();
		},

		routeHank(value) {
			if (this.isManager) return;
			switch (value.name) {
				case "assessmentList":
					value.meta.showBack = false;
					value.meta.parent = [];
					break;
				case "assessment":
					value.meta.parent = ["assessmentList"];
					break;
				case "archivedAssessmentList":
				case "archivedTask":
					value.meta.parent = ["assessmentList"];
					break;
				default:
					break;
			}
		}
	},
};
</script>

<style lang="less" scoped>
.layout {
	&-container {
		// margin-left: 255px;
		// transition: all 0.3s;
		height: 100vh;
		background: #f0f2f5;

		/deep/.ant-menu-inline {
			border-right: none;
		}
	}

	&-logo {
		display: block;
		width: 107px;
		height: 107px;
		margin: 40px auto 10px;
		cursor: pointer;

		&_collapsed {
			width: 40px;
			height: 40px;
			margin: 20px auto;
		}
	}

	&-name {
		height: 21px;
		margin-bottom: 48px;
		line-height: 21px;
		font-size: 16px;
		color: #343c6a;
		text-align: center;
	}

	&-sider {
		height: 100%;
		overflow-y: auto;
		overflow-x: auto;
		background-color: #fff;

		&::-webkit-scrollbar {
			/*滚动条整体样式*/
			width: 0px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 0px;
		}
	}

	&-header {
		padding: 4px 20px;
		background-color: #fff;
		border-left: 5px solid #f0f2f5;
		height: 60px;
		line-height: 52px;

		&_avatar {
			float: left;
			width: 35px;
			height: 35px;
			margin: 9px 18px 0 0;
			border-radius: 50%;
			cursor: pointer;
			background-size: cover !important;
		}

		&_name {
			font-size: 16px;
			color: #343c6a;
			cursor: pointer;
		}

		&_logout {
			display: inline-block;
			width: 35px;
			height: 35px;
			margin: 0 10px 0 54px;
			background: #f0f2f5;
			border-radius: 50%;
			text-align: center;
			line-height: 35px;
			font-size: 20px;
			color: rgb(254, 92, 115);
			cursor: pointer;
		}

		&_menu {
			font-size: 18px;
		}

		&_user {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
		}
	}

	&-title {
		height: 24px;
		padding-right: 100px;
		box-sizing: content-box;
		line-height: 24px;
		background: #f0f2f5;
		font-size: 14px;

		&_cur {
			color: #343c6a;
			cursor: default !important;
		}

		&_parent {
			color: #909399;
			cursor: pointer;
		}

		&_icon {
			margin: 0 4px;
		}

		&_list {
			padding-right: 0;
		}
	}

	&-content {
		position: relative;
		height: calc(~"100vh - 64px");
		padding: 20px 28px 23px 28px;
		// background: #ffffff;
		overflow: auto;
	}

	&-menu {
		&_name {
			margin-left: 25px;
			font-size: 16px;
		}

		&_icon {
			font-size: 24px;
		}
	}

	&-back {
		cursor: pointer;
		color: #343c6a;
	}
}
</style>
